import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

// 계약서 상세 페이지 styled (Figma — 계약서 만들기 > 계약서 정보)
// Primary #4AB3BC · Gray #737373 · Border #D9D9D9 · BG #fafbfc

// ============================================
// 전체 레이아웃
// ============================================
export const DetailContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
  marginTop: '16px',
  padding: '32px',
  background: '#fafbfc',
  borderRadius: '8px',
  boxShadow: '0px 0px 2px rgba(0,0,0,0.16)',
});

// ============================================
// 상단 회원 정보 바
// ============================================
export const MemberBar = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: '16px 24px',
  background: '#fff',
  borderRadius: '8px',
  border: '1px solid #D9D9D9',
});

export const MemberInfoGroup = styled(Box)({
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
});

export const MemberName = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#262626',
});

export const MemberBadge = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2px 10px',
  borderRadius: '4px',
  background: '#4AB3BC',
  color: '#fff',
  fontSize: '13px',
  fontWeight: 600,
});

export const MemberDivider = styled(Box)({
  width: '1px',
  height: '20px',
  background: '#D9D9D9',
});

export const MemberText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#737373',
});

export const MemberDetailButton = styled(Button)({
  minWidth: 'auto',
  height: '36px',
  padding: '6px 20px',
  borderRadius: '4px',
  background: '#262626',
  color: '#fff',
  fontSize: '14px',
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  '&:hover': { background: '#404040', boxShadow: 'none' },
});

export const ActionButtonGroup = styled(Box)({
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
});

export const PdfDownloadWrap = styled(Box)({
  position: 'relative',
  '&:hover > .download-menu': {
    display: 'flex',
  },
});

export const PdfDownloadButton = styled(Button)({
  height: '44px',
  padding: '8px 20px',
  gap: '8px',
  borderRadius: '8px',
  background: '#fff',
  color: '#EF5350',
  border: '1px solid #EF5350',
  fontSize: '16px',
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': { background: '#fff', boxShadow: 'none' },
});

export const DownloadMenu = styled(Box)({
  display: 'none',
  flexDirection: 'column',
  position: 'absolute',
  top: 'calc(100% - 4px)',
  right: 0,
  paddingTop: '8px',
  minWidth: '220px',
  zIndex: 10,
});

export const DownloadMenuInner = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  background: '#fff',
  border: '1px solid #D9D9D9',
  borderRadius: '8px',
  boxShadow: '0px 4px 12px rgba(0,0,0,0.12)',
  overflow: 'hidden',
});

export const DownloadMenuItem = styled(Button)({
  width: '100%',
  padding: '12px 16px',
  fontSize: '14px',
  fontWeight: 500,
  color: '#333',
  textTransform: 'none',
  justifyContent: 'flex-start',
  gap: '8px',
  borderRadius: 0,
  '&:hover': { background: '#f5f5f5' },
});

export const BackToListButton = styled(Button)({
  height: '44px',
  padding: '8px 24px',
  borderRadius: '8px',
  background: '#262626',
  color: '#fff',
  fontSize: '16px',
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': { background: '#404040', boxShadow: 'none' },
});

// ============================================
// 2컬럼 본문 (좌: 계약서, 우: 영수증)
// ============================================
export const ContentRow = styled(Box)({
  display: 'flex',
  gap: '24px',
  alignItems: 'stretch',
  width: '100%',
});

export const LeftPanel = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const RightPanel = styled(Box)({
  width: '360px',
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

// ============================================
// 전자 계약서 섹션
// ============================================
export const SectionLabel = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#4AB3BC',
});

export const ContractDocWrapper = styled(Box)({
  width: '100%',
  height: '160vh',
  background: '#fff',
  border: '1px solid #D9D9D9',
  borderRadius: '8px',
  overflow: 'hidden',
});

// ============================================
// 영수증 카드
// ============================================
export const ReceiptCard = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  padding: '24px',
  background: '#fff',
  border: '1px solid #D9D9D9',
  borderRadius: '8px',
  minHeight: '160px',
});

export const ReceiptTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#4AB3BC',
});

export const ReceiptEmpty = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  color: '#A6A6A6',
});

export const ReceiptEmptyText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#A6A6A6',
});

export const ReceiptImage = styled('img')({
  width: '100%',
  borderRadius: '6px',
  border: '1px solid #D9D9D9',
  padding: '8px',
  background: '#fff',
  cursor: 'pointer',
  '&:hover': { opacity: 0.85 },
});

export const ReceiptPdfLink = styled(Button)({
  width: '100%',
  padding: '12px 16px',
  borderRadius: '6px',
  border: '1px solid #D9D9D9',
  background: '#fafbfc',
  color: '#333',
  fontSize: '13px',
  fontWeight: 500,
  textTransform: 'none',
  justifyContent: 'flex-start',
  gap: '8px',
  '&:hover': { background: '#f0f0f0' },
});

export const SourceInfoRow = styled(Box)({
  display: 'flex',
  gap: '12px',
});

export const SourceInfoLabel = styled(Typography)({
  fontSize: '13px',
  color: '#737373',
  minWidth: '72px',
  flexShrink: 0,
});

export const SourceInfoValue = styled(Typography)({
  fontSize: '13px',
  color: '#1a1a1a',
  wordBreak: 'break-all',
});

export const ReceiptPdfViewer = styled(Box)({
  width: '100%',
  height: '533px',
  border: '1px solid #D9D9D9',
  borderRadius: '4px',
  overflow: 'hidden',
});
